import React from "react";

import { SvgWrapper } from "../styles";

interface SvgComponentProps {
  height: number;
  width: number;
  color: string;
}

const IconActivity = (props: SvgComponentProps) => {
  const { width, height, color } = props;

  return (
    <SvgWrapper>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
        fill="none"
      >
        <path
          d="M12.5 18.9584H7.49999C2.97499 18.9584 1.04166 17.0251 1.04166 12.5001V7.50008C1.04166 2.97508 2.97499 1.04175 7.49999 1.04175H12.5C17.025 1.04175 18.9583 2.97508 18.9583 7.50008V12.5001C18.9583 17.0251 17.025 18.9584 12.5 18.9584ZM7.49999 2.29175C3.65832 2.29175 2.29166 3.65841 2.29166 7.50008V12.5001C2.29166 16.3417 3.65832 17.7084 7.49999 17.7084H12.5C16.3417 17.7084 17.7083 16.3417 17.7083 12.5001V7.50008C17.7083 3.65841 16.3417 2.29175 12.5 2.29175H7.49999Z"
          fill={color}
        />
        <path
          d="M6.10832 12.7001C5.97499 12.7001 5.84166 12.6584 5.72499 12.5667C5.44999 12.3584 5.39999 11.9667 5.60832 11.6917L7.59166 9.11675C7.83332 8.80841 8.17499 8.60842 8.56666 8.55842C8.94999 8.50842 9.34166 8.61675 9.64999 8.85842L11.175 10.0584C11.2333 10.1084 11.2917 10.1084 11.3333 10.1001C11.3667 10.1001 11.425 10.0834 11.475 10.0167L13.4 7.53341C13.6083 7.25841 14.0083 7.20842 14.275 7.42508C14.55 7.63341 14.6 8.02508 14.3833 8.30008L12.4583 10.7834C12.2167 11.0917 11.875 11.2917 11.4833 11.3334C11.0917 11.3834 10.7083 11.2751 10.4 11.0334L8.87499 9.83342C8.81666 9.78342 8.74999 9.78341 8.71666 9.79175C8.68332 9.79175 8.62499 9.80842 8.57499 9.87508L6.59166 12.4501C6.48332 12.6167 6.29999 12.7001 6.10832 12.7001Z"
          fill={color}
        />
      </svg>
    </SvgWrapper>
  );
};

export default IconActivity;
